export default __webpack_public_path__ + "static/media/jacket-3.70a0e9ed.jpg";